<div
  class="drilldown-table-scroll-viewport"
  [ngClass]="size"
  [style.height]="size === 'medium' ? '100%' : null"
  #tableScrollViewport
>
  <table
    mat-table
    class="mat-table"
    [dataSource]="dataSource"
    *ngIf="data.rows.length > 0; else noDataTemplate"
  >
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef [ngClass]="getColumnClass(column)">
        <span overflowTooltip class="drilldown-table-overflow-label">{{ column.label }}</span>
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="getColumnClass(column)">
        <ng-container *ngIf="isSpacerRow(element); else nonSpacerCell">
          <span class="drilldown-table-spacer-cell"></span>
        </ng-container>
        <ng-template #nonSpacerCell>
          <ng-container *ngIf="column.isBadge; else defaultCell">
            <status-badge
              [type]="'studyMilestoneStatus'"
              [badgeKey]="element[column.key]"
              [showLabel]="size !== 'small'"
            >
            </status-badge>
          </ng-container>
        </ng-template>
        <ng-template #defaultCell>
          <span overflowTooltip class="drilldown-table-overflow-label">{{
            formatLabel(column, element[column.key])
          }}</span>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsKeys"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumnsKeys"
      [class.drilldown-table-spacer-row]="isSpacerRow(row)"
      [style.height.px]="isSpacerRow(row) ? getSpacerRowHeight() : null"
    ></tr>
  </table>
</div>

<ng-template #noDataTemplate>
  <drilldown-chart-no-data-available [size]="size"></drilldown-chart-no-data-available>
</ng-template>
